<template>
  <div class="check">
    <el-dialog
      :title="$t('cooperation.dialogTitle.checkResult')"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <el-progress :percentage="progress" :status="status"></el-progress>
      <!-- 查重结果 -->
      <div class="result" v-if="checkedResult.length">
        <p v-for="(item, index) of checkedResult" :key="index">
          <span>{{ item.supplierName }}：{{ '(' + item.supplierCode + ')' }}</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleClose">{{
          $t('cooperation.buttons.sure')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/supplyChain.js';
  export default {
    name: 'check',
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        dialogVisible: false,
        propsData: null,
        progress: 0, // 进度条
        status: null, // 进度条状态
        checkedResult: [], // 查重结果
      };
    },
    methods: {
      openDialog(data) {
        this.progress = 20;
        this.dialogVisible = true;
        this.propsData = data;
        this.check();
      },
      check() {
        let params = {
          supplierName: this.propsData.supplierName,
          departmentCode: this.userInfo.departmentCode,
        };
        this.$axios.get(API.DUPLICATE_CHECK, params).then((res) => {
          if (res.data.code === 0) {
            this.progress = 100;
            this.checkedResult = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            this.status = 'exception';
          }
        });
      },
      handleClose() {
        this.progress = 0;
        this.status = null;
        this.checkedResult = [];
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .check .result p {
    margin: 5px 0;
  }
</style>
